import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin")({
	beforeLoad: () => {
		const host = window.location.hostname;
		let adminUrl = "http://localhost:3001";
		if (host.includes("staging")) {
			adminUrl = "https://admin.staging.americamajority.org";
		} else if (host.includes("dev")) {
			adminUrl = "https://admin.dev.americamajority.org";
		} else if (!host.includes("localhost")) {
			adminUrl = "https://admin.app.americamajority.org";
		}
		// Preserve sub-path so /admin/users redirects to admin.domain/users
		const subPath = window.location.pathname.replace(/^\/admin\/?/, "/");
		window.location.href = adminUrl + (subPath === "/" ? "" : subPath);
	},
	component: () => <Outlet />,
});
